<template>
    <Button class="like"
        appearance="transparent"
        :disabled="disableLikeAction"
        :iconOnly="true"
        size="small"
        @click="$emit('handleLike')">
        <div class="sparkling"
            :class="{ animate }">
            <span v-if="isLiked"
                class="favorite icon">
            </span>
            <span v-else
                class="favorite-border icon">
            </span>
        </div>
    </Button>
</template>

<script>
    export default {
        name: 'LikeIcon',
        props: {
            isLiked: {
                type: Boolean,
                required: true
            },
            disableLikeAction: {
                type: Boolean,
                required: true
            },
            animate: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon {
        height: 2rem;
        width: 2rem;
    }

    .favorite {
        content: var(--favorite);
    }

    .favorite-border {
        content: var(--favorite-border);
    }

    .sparkling {
        display: flex;
    }

    .animate {
        position: relative;

        &:before, &:after {
            position: absolute;
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            transition: all ease-in-out 0.5s;
            background-repeat: no-repeat;
            transform: scale(2);
        }

        &:before {
            display: none;
            top: -75%;
            background-image: radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%), radial-gradient(circle, transparent 20%, var(--color-primary-500) 20%, transparent 30%), radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%), radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%), radial-gradient(circle, transparent 10%, var(--color-primary-500) 15%, transparent 20%), radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%), radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%), radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%), radial-gradient(circle, var(--color-primary-500) 20%, transparent 20%);
            background-size: 40% 40%, 60% 60%, 55% 55%, 40% 40%, 20% 20%, 5% 5%, 30% 30%, 20% 20%, 30% 130%;
        }

        &:after {
            display: none;
            bottom: -75%;
            background-image: radial-gradient(circle, var(--color-red-500) 20%, transparent 20%), radial-gradient(circle, var(--color-red-500) 20%, transparent 20%), radial-gradient(circle, transparent 10%, var(--color-red-500) 15%, transparent 20%), radial-gradient(circle, var(--color-red-500) 20%, transparent 20%), radial-gradient(circle, var(--color-red-500) 20%, transparent 20%), radial-gradient(circle, var(--color-red-500) 20%, transparent 20%), radial-gradient(circle, var(--color-red-500) 20%, transparent 20%);
            background-size: 40% 40%, 60% 60%, 55% 55%, 40% 40%, 20% 20%, 5% 5%, 30% 30%, 20% 20%, 30% 130%;
        }

        &.animate:before {
            display: block;
            animation: topBubbles ease-in-out 0.75s forwards;
        }

        &.animate:after {
            display: block;
            animation: bottomBubbles ease-in-out 0.75s forwards;
        }

        @keyframes topBubbles {  
            0% {
                background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%, 40% 90%, 55% 90%, 70% 90%;
            }
            50% {
                background-position: 0% 80%, 0% 20%, 10% 40%, 20% 0%, 30% 30%, 22% 50%, 50% 50%, 65% 20%, 90% 30%;
            }
            100% {
                background-position: 0% 70%, 0% 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%, 50% 40%, 65% 10%, 90% 20%;
                background-size: 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%;
            }
        }

        @keyframes bottomBubbles {  
            0% {
                background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%, 70% -10%, 70% 0%;
            }
            50% {
                background-position: 0% 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%, 105% 0%;
            }
            100% {
                background-position: 0% 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%, 110% 10%;
                background-size: 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%;
            }
        }
    }
</style>